import JH_BoldTextFace from './JH_BoldTextFace';
import JH_AnnotatedFace from './JH_AnnotatedFace';
import JH_FaceWithCard from './JH_FaceWithCard';
import JH_MetricCards from './JH_MetricCards';
import JH_TierList from './JH_TierList';
import JH_ProcessFlow from './JH_ProcessFlow';
import V_ObjectSerif from './V_ObjectSerif';
import V_QuestionArrow from './V_QuestionArrow';
import V_StatementEmphasis from './V_StatementEmphasis';
import V_ConceptIllustration from './V_ConceptIllustration';
import V_PhotoOverlay from './V_PhotoOverlay';
import V_DataSubject from './V_DataSubject';

const TEMPLATES = {
  '1':  { id: '1',  name: 'Bold Text + Face',        style: 'jh',         component: JH_BoldTextFace,        needsPerson: true,  needsSubject: false },
  '2':  { id: '2',  name: 'Annotated Face',           style: 'jh',         component: JH_AnnotatedFace,       needsPerson: true,  needsSubject: false },
  '3':  { id: '3',  name: 'Face + Card/Board',        style: 'jh',         component: JH_FaceWithCard,        needsPerson: true,  needsSubject: false },
  '4':  { id: '4',  name: 'Metric Cards + Face',      style: 'jh',         component: JH_MetricCards,         needsPerson: true,  needsSubject: false },
  '5':  { id: '5',  name: 'Tier List',                style: 'jh',         component: JH_TierList,            needsPerson: true,  needsSubject: false },
  '6':  { id: '6',  name: 'Process Flow',             style: 'jh',         component: JH_ProcessFlow,         needsPerson: true,  needsSubject: false },
  '7':  { id: '7',  name: 'Object + Large Serif',     style: 'veritasium', component: V_ObjectSerif,          needsPerson: false, needsSubject: true },
  '8':  { id: '8',  name: 'Question + Arrow',         style: 'veritasium', component: V_QuestionArrow,        needsPerson: false, needsSubject: true },
  '9':  { id: '9',  name: 'Statement + Emphasis',     style: 'veritasium', component: V_StatementEmphasis,    needsPerson: false, needsSubject: true },
  '10': { id: '10', name: 'Concept Illustration',     style: 'veritasium', component: V_ConceptIllustration,  needsPerson: false, needsSubject: true },
  '11': { id: '11', name: 'Photo + Minimal Overlay',  style: 'veritasium', component: V_PhotoOverlay,         needsPerson: false, needsSubject: false },
  '12': { id: '12', name: 'Data + Subject',           style: 'veritasium', component: V_DataSubject,          needsPerson: false, needsSubject: true },
};

export default TEMPLATES;

export const JH_TEMPLATES = Object.values(TEMPLATES).filter(t => t.style === 'jh');
export const V_TEMPLATES  = Object.values(TEMPLATES).filter(t => t.style === 'veritasium');
